import React, { useEffect, useState } from "react";
import { buildWaLink } from "../../lib/constants";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { useLang } from "../../context/LanguageContext";

export const WhatsAppFloat = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={buildWaLink(
        lang === "it"
          ? "Ciao Annette Rooms, vorrei informazioni."
          : "Hello Annette Rooms, I'd like some information."
      )}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      className={`fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl hover:bg-[#1faa52] transition-all duration-500 ${
        visible
          ? "translate-y-0 opacity-100"
          : "translate-y-10 opacity-0 pointer-events-none"
      }`}
      aria-label="Contact via WhatsApp"
    >
      <span className="relative flex">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-30" />
        <WhatsAppIcon className="w-6 h-6 relative" />
      </span>
      <span className="text-xs uppercase tracking-[0.2em] hidden sm:inline">
        WhatsApp
      </span>
    </a>
  );
};
